import { fromJS } from 'immutable';
import { setStateParamsType } from '@Constants/StateParamsConstants';

export const initialState = fromJS({

});

export default function stateParamsReducer (state = initialState, action) {
  switch (action.type) {
    case setStateParamsType: {
      return fromJS(action.payload);
    }

    default: {
      return state;
    }
  }
}
